import React, { useState } from 'react';
import {
	DndContext,
	closestCenter,
	KeyboardSensor,
	PointerSensor,
	useSensor,
	useSensors,
	DragOverlay
} from '@dnd-kit/core';
import {
	arrayMove,
	SortableContext,
	sortableKeyboardCoordinates,
	verticalListSortingStrategy
} from '@dnd-kit/sortable';

import { SortableItem } from 'components/DnDSortalbe/SortableItem';
import * as S from './styles';
import { color } from 'styles/pallete';

type ListVerticalDragAndDropProps = {
	listItens: any[];
	setListItens: React.Dispatch<React.SetStateAction<any[]>>;
	// eslint-disable-next-line no-unused-vars
	returnItemList: (training: any) => JSX.Element;
	colorIconDrag?: string;
	sizeIconDrag?: string;
	showBtnDrag?: boolean;
};

export default function ListVerticalDragAndDrop({
	listItens,
	setListItens,
	returnItemList,
	colorIconDrag = color.interface.lightGray,
	sizeIconDrag = '2rem',
	showBtnDrag = false
}: ListVerticalDragAndDropProps) {
	const [activeId, setActiveId] = useState<string | null>(null);
	const [draggingElement, setDraggingElement] = useState<any>(null);

	const sensors = useSensors(
		useSensor(PointerSensor),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates
		})
	);

	function handleDragStart(event: any) {
		const { active } = event;
		setActiveId(active.id);

		const activeElement = document.querySelector(`[data-id="${active.id}"]`);
		if (activeElement) {
			setDraggingElement(activeElement.outerHTML);
		}
	}

	function handleDragEnd(event: any) {
		const { active, over } = event;

		setActiveId(null);
		setDraggingElement(null);

		if (!over || active.id === over.id) return;

		const oldIndex = listItens.findIndex((item) => item.id === active.id);
		const newIndex = listItens.findIndex((item) => item.id === over.id);

		if (oldIndex !== -1 && newIndex !== -1) {
			setListItens(arrayMove(listItens, oldIndex, newIndex));
		}
	}

	function handleDragCancel() {
		setActiveId(null);
		setDraggingElement(null);
	}

	return listItens.length > 0 ? (
		<DndContext
			sensors={sensors}
			collisionDetection={closestCenter}
			onDragStart={handleDragStart}
			onDragEnd={handleDragEnd}
			onDragCancel={handleDragCancel}
		>
			<S.container>
				<SortableContext
					items={listItens.map((item) => item.id)}
					strategy={verticalListSortingStrategy}
				>
					{listItens.map((item) => (
						<SortableItem
							id={item.id}
							key={item.id}
							colorIconDrag={colorIconDrag}
							sizeIconDrag={sizeIconDrag}
							showBtnDrag={showBtnDrag}
						>
							{returnItemList(item)}
						</SortableItem>
					))}
				</SortableContext>
			</S.container>

			<DragOverlay>
				{activeId && draggingElement && (
					<div
						dangerouslySetInnerHTML={{ __html: draggingElement }}
						style={{
							pointerEvents: 'none',
							backgroundColor: color.interface.onDragColor,
							cursor: 'grabbing',
							padding: '10px',
							borderRadius: '8px',
							boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)'
						}}
					/>
				)}
			</DragOverlay>
		</DndContext>
	) : (
		<S.emptyList>
			<p>Não há itens na lista</p>
		</S.emptyList>
	);
}
